/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetEvaluationPathParams = NonNullable<operations['getEvaluation']['parameters']['path']>;

export type GetEvaluationQueryParams = NonNullable<operations['getEvaluation']['parameters']['query']>;

export interface Input extends GetEvaluationPathParams {
  apiVersion?: string;
  query?: GetEvaluationQueryParams;
}

export async function getEvaluation(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/evaluations/{evaluationId}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
